import { Col, Container, Row } from "react-bootstrap";
import { useState, useEffect } from 'react';
import logo from '../assets/images/sds-logo.svg';
import Collapse from 'react-bootstrap/Collapse';
import { Link } from "react-router-dom";
import useCustom from "../hooks/useCustom";
import contactData from '../assets/static_datas/contact.json';
import axios from 'axios';
import { getApiUrl } from '../config/api';
import { GoogleMap } from '@veeyaainnovatives/google-map';

const Footer = () => {
  const { bookMySeat } = useCustom();

  const [openService, setOpenService] = useState(true);
  const [openCareer, setOpenCareer] = useState(true);
  const [openContact, setOpenContact] = useState(true);
  const [parentServices, setParentServices] = useState([]);


  useEffect(() => {
    autoResize();
    window.addEventListener('resize', autoResize);
    return () => window.removeEventListener('resize', autoResize);
  }, []);

  // Fetch parent services from API
  useEffect(() => {
    const fetchParentServices = async () => {
      try {
        const response = await axios.get(getApiUrl('api/public/services/all-with-children'));
        
        if (response.data.success && response.data.data) {
          // Filter only parent services (services without parent_id or with null parent_id) and published
          const parents = response.data.data.filter(service => 
            (!service.parent_id || service.parent_id === null) && service.is_published === 1
          );
          
          // Sort by title/name
          parents.sort((a, b) => {
            const nameA = (a.title || a.name || '').toLowerCase();
            const nameB = (b.title || b.name || '').toLowerCase();
            return nameA.localeCompare(nameB);
          });
          
          setParentServices(parents);
        }
      } catch (error) {
        console.error('Error fetching parent services for footer:', error);
        // Fallback to empty array on error
        setParentServices([]);
      }
    };

    fetchParentServices();
  }, []);

  const autoResize = () => {
    if (window.innerWidth < 767) {
      setOpenService(false);
      setOpenCareer(false);
      setOpenContact(false);

    } else {
      setOpenService(true);
      setOpenCareer(true);
      setOpenContact(true);
    }
  }

  return (
    <>
      <footer className="hidden-in-pdf-view">
        <div className="footer-section">
          <Container>
            <Row>
              <Col xl={3}>
                <img src={logo} alt="logo" className="footer-logo" />

                <p className="footer-description">Sathiesh Design Studio is Chennai’s first fully integrated architecture, interior design, construction, plan approval, structural, MEP, 3D VR/AR, and 3D laser scanning studio.
                  We deliver complete home design–build solutions with zero coordination hassle and complete transparency – Specialised for NRI Clients
                </p>
                <div className="social-media-list mb-5">
                  <a href="/"><span className="fa-brands fa-facebook-f"></span></a>
                  <a href="/"><span className="fa-brands fa-linkedin-in"></span></a>
                  <a href="/"><span className="fa-brands fa-x-twitter"></span></a>
                  <a href="/"><span className="fa-brands fa-instagram"></span></a>
                </div>
              </Col>
              <Col xl={8} className="ps-md-5">
                <Row>
                  <Col lg={2}>
                    <h1 className="footer-list-title" onClick={() => setOpenService(!openService)}>Quick Links <i className="fa-solid fa-chevron-down float-right d-lg-none d-inline"></i></h1>
                    <Collapse in={openService}>
                      <ul className="list-unstyled footer-list" id="servicesList">
                        <li><Link to="/" >Home</Link></li>
                        <li><Link to="/about-us" >About Us</Link></li>
                        <li><Link to="/our-pricing" >Our Pricing</Link></li>
                        <li><Link to="/services" >Services</Link></li>
                        <li><Link to="/portfolio">Portfolio</Link></li>
                        <li><Link to="/faq">FAQ</Link></li>
                        <li><Link to="/blogs">Blogs</Link></li>
                        <li><Link to="/contact-us">Contact Us</Link></li>
                        <li><Link to="/careers">Careers</Link></li>
                      </ul>
                    </Collapse>
                  </Col>
                  <Col lg={6}>
                    <h1 className="footer-list-title" onClick={() => setOpenCareer(!openCareer)}>Services <i className="fa-solid fa-chevron-down  float-right d-lg-none d-inline"></i></h1>
                    <Collapse in={openCareer}>
                      <ul className="list-unstyled footer-list" id="servicesList">
                        {parentServices.length > 0 ? (
                          parentServices.map((service) => (
                            <li key={service.id}>
                              <Link to={`/services/${service.slug}`}>
                                {service.title || service.name}
                              </Link>
                            </li>
                          ))
                        ) : (
                          <li>Loading services...</li>
                        )}
                      </ul>
                    </Collapse>
                  </Col>
                  <Col lg={4}>
                    <h1 className="footer-list-title" onClick={() => setOpenContact(!openContact)}>Contact Us With <i className="fa-solid fa-chevron-down  float-right d-lg-none d-inline"></i></h1>
                    <Collapse in={openContact}>
                      <ul className="list-unstyled footer-list address" id="contactList">
                        <li><a href={`tel:${contactData.phone.replace(/\s/g, '')}`} ><span className="fa fa-phone me-1"></span> {contactData.phone}</a></li>
                        <li><a href={`mailto:${contactData.email}`} ><span className="fa fa-envelope me-1"></span> {contactData.email}</a></li>
                        <li><a href={void (0)} ><span className="fa fa-map-marker me-2"></span>{contactData.address}</a></li>
                      </ul>
                    </Collapse>
                    <div className="footer-map-container mt-4">
                      <GoogleMap
                        embedUrl={contactData.map.embed_url}
                        title="SDS Location"
                        height={200}
                        width="100%"
                        style={{ borderRadius: '8px' }}
                      />
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="footer-rights-sections text-center">
          <p>&copy; 2025 Sathish Design Studio. All rights reserved &nbsp; | &nbsp;  Designed & Developed by <a href="https://veeyaainnovatives.com/" target="_blank" rel="noopener noreferrer">VeeyaInnovatives</a></p>
        </div>
      </footer>
    </>
  );
}

export default Footer;
